import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { parsingRules } from '../../../../../../redux/parsing-rules/action';
import { deepCopy } from '../../../../../../common/services/common.service';
import PageLoader from '../../../../../../components/PageLoader';
import * as R from 'ramda';
import { selectParsingRulesListItems, selectParsingRulesQueryItems } from '../../../../../../redux/parsing-rules/selector';
import { selectListItems } from '../../../../../../redux/library/selector';
import ConvertFileComponent from '../components/convert-file.component';

let currentChange: any = {};

const ManagementConvertFile = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const params: any = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [parsingRuleId, setParsingRuleId] = useState<number>(params.id);
  const queryItems = useSelector(selectParsingRulesQueryItems);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const libraryData = useSelector(selectListItems);
  const itemsData = useSelector(selectParsingRulesListItems);
  const [fieldConversions, setFieldConversions] = useState<any>([]);
  const [convertFile, setConvertFile] = useState<any>([]);
  const [selectedConvertFile, setSelectedConvertFile] = useState<any>([]);

  const fetchRecordById = () => {
    dispatch(parsingRules.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/service/parsing-rules/query`,
      entity: 'parsingRules',
      jsonData: {
        Records: [
          {
            "Id": parsingRuleId
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  };

  useEffect(() => {
    dispatch(parsingRules.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/service/parsing-rules/list`,
      entity: 'parsingRules',
      jsonData: {}
    }));
    if (parsingRuleId > 0) {
      fetchRecordById();
      setIsLoading(false);
    } else {
      const localSelectedService = addNewRow({ selectedServiceArg: fieldConversions });
      setFieldConversions(localSelectedService);
      setIsLoading(false);
    }
  }, [selectedConvertFile, parsingRuleId]);

  useEffect(() => {
    if (isQuery) {
      setConvertFile(queryItems?.result?.items);
      const localSelectedService = addNewRow({ selectedServiceArg: queryItems?.result?.items?.Options?.FieldConversions });
      setFieldConversions(localSelectedService);
    }
  }, [isQuery]);

  const handleInnerBasicFormChange: any = (event: any, field: string) => {
    setConvertFile({ ...convertFile, [field]: event });
    setSelectedConvertFile({ ...selectedConvertFile, [field]: event });
    setParsingRuleId(event);
  };

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split('.', field);
    const value = { ...data, [fields[1]]: event }; // inner data update
    setConvertFile({ ...convertFile, [fields[0]]: value });
  };

  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(fieldConversions); // deep copy of grn items
    let item = items[idx]; // deep copy of item to be edited
    item = { ...item, [field]: value }; // updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx };
    setFieldConversions(items);
  };

  const deleteSelectedService = async (Item: any, index: any) => {
    if (Item.Id === 0) {
      fieldConversions?.splice(index, 1);
    }
  };

  const addNewRow = ({ selectedServiceArg }: any) => {
    const localSelectedservice = deepCopy(selectedServiceArg);
    const newRowFieldConversion = {
      Id: 0,
      InputFieldIndex: '',
      InputFieldType: '',
      OutputFieldIndex: '',
      OutputFieldType: '',
      OutputHeaderText: ''
    };
    if (localSelectedservice.length === 0 ||
      localSelectedservice[localSelectedservice?.length - 1]?.InputFieldIndex !== '') {
      localSelectedservice?.push(newRowFieldConversion);
    }
    return localSelectedservice;
  };

  const setCombinationInfo = async () => {
    let localSelectedService = deepCopy(fieldConversions);
    localSelectedService.splice(currentChange.idx, 1, { ...localSelectedService[currentChange.idx] });
    localSelectedService = addNewRow({ selectedServiceArg: localSelectedService });
    currentChange.field = 'InputFieldIndexDONE';
    setFieldConversions(localSelectedService);
  };

  useEffect(() => {
    if (currentChange.field === 'InputFieldIndex') {
      setCombinationInfo();
    }
  }, [fieldConversions]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    fieldConversions.splice(fieldConversions.length - 1, 1);
    convertFile.Options.FieldConversions = fieldConversions;
    dispatch(convertFile.create({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/service/parsing-rules/convert-file`,
      entity: 'convertFile',
      jsonData: {
        Records: [convertFile]
      }
    })).then(() => {
      back();
    });
  };

  const back = () => {
    navigate('/management/system/service/parsing-rules');
  };

  return (
    <>
      {isLoading ? <PageLoader /> :
        <ConvertFileComponent
          handleInnerFormChange={handleInnerFormChange}
          parsingRule={itemsData?.result?.items}
          handleFormSubmit={handleFormSubmit}
          back={back}
          deleteSelectedService={deleteSelectedService}
          handleFormItemChange={handleFormItemChange}
          handleInnerBasicFormChange={handleInnerBasicFormChange}
          fieldConversions={fieldConversions}
          convertFile={convertFile}
          fieldType={libraryData?.result?.FieldType}
          formatType={libraryData?.result?.FileFormatType}
          fetchRecordById={fetchRecordById}
          selectedConvertFile={selectedConvertFile}
        />}
    </>
  );
};

export default ManagementConvertFile;